export default __webpack_public_path__ + "static/media/sticky-note-solid.83c8e62f.svg";